import { useEffect, useState } from "react";

// Returns whether `query` currently matches, kept in sync via the
// MediaQueryList's own change event (not a resize listener) so it also
// reacts to things resize alone wouldn't, e.g. orientation/hover changes.
export const useMediaQuery = (query) => {
  const getMatches = () =>
    typeof window !== "undefined" && window.matchMedia(query).matches;

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handleChange = () => setMatches(mql.matches);
    handleChange();
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
};
